import React from 'react';
import { UserInfo } from '../../api/admin';
import Button from '../ui/Button';

interface UserTableProps {
  users: UserInfo[];
  onEditUser: (user: UserInfo) => void;
  onDeleteUser: (user: UserInfo) => void;
  currentUsername?: string;
}

const UserTable: React.FC<UserTableProps> = ({ users, onEditUser, onDeleteUser, currentUsername }) => {
  return (
    <div className="border rounded-lg overflow-hidden">
      <table className="min-w-full divide-y divide-slate-200">
        <thead className="bg-slate-50">
          <tr>
            <th className="px-4 py-3 text-left text-xs font-medium text-slate-500 uppercase tracking-wider">Username</th>
            <th className="px-4 py-3 text-left text-xs font-medium text-slate-500 uppercase tracking-wider">Role</th>
            <th className="px-4 py-3 text-left text-xs font-medium text-slate-500 uppercase tracking-wider">Created</th>
            <th className="px-4 py-3 text-left text-xs font-medium text-slate-500 uppercase tracking-wider">Actions</th>
          </tr>
        </thead>
        <tbody className="bg-white divide-y divide-slate-200">
          {users.map((userItem) => (
            <tr key={userItem.id}>
              <td className="px-4 py-3 whitespace-nowrap text-sm font-medium text-slate-900">
                {userItem.username}
                {userItem.username === currentUsername && <span className="ml-2 text-xs text-slate-500">(You)</span>}
              </td>
              <td className="px-4 py-3 whitespace-nowrap">
                <span
                  className={`inline-flex px-2 py-1 text-xs font-semibold rounded-full ${
                    userItem.role === 'admin' ? 'bg-red-100 text-red-800' : 'bg-blue-100 text-blue-800'
                  }`}
                >
                  {userItem.role}
                </span>
              </td>
              <td className="px-4 py-3 whitespace-nowrap text-sm text-slate-500">{new Date(userItem.createdAt).toLocaleString()}</td>
              <td className="px-4 py-3 whitespace-nowrap text-sm text-slate-500">
                <div className="flex space-x-2">
                  <Button size="sm" variant="primary" onClick={() => onEditUser(userItem)}>
                    Edit
                  </Button>
                  {userItem.username !== currentUsername && (
                    <Button size="sm" variant="danger" onClick={() => onDeleteUser(userItem)}>
                      Delete
                    </Button>
                  )}
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default UserTable;
